/**
 * [这是一个空方法]
 *
 * @export
 */
export function noopFunc() {}

export function sleep(time = 0) {
	return new Promise((resolve) => setTimeout(resolve, time));
}

export function isUndefined(_val: any): _val is undefined {
	return typeof _val === 'undefined';
}

export function getRandom(_min = 0, _max = 100, fixed = 0) {
	return Number((Math.random() * (_max - _min) + _min).toFixed(fixed));
}

/**
 * 从对象中提取指定的字段
 */
export function extractFields(target: Record<string, any>, keys: Array<string>) {
	const returnObj: Record<string, any> = {};
	for (const key of keys) {
		if (target.hasOwnProperty(key)) {
			returnObj[key] = target[key];
		}
	}
	return returnObj;
}

export function compose(...funcs: any[]) {
	if (funcs.length === 0) {
		return (arg: any) => arg;
	}

	if (funcs.length === 1) {
		return funcs[0];
	}

	return funcs.reduce(
		(a, b) =>
			(...args: any) =>
				a(b(...args)),
	);
}
